import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface ConfirmationModalProps {
  show: boolean;
  emailCount: number;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmationModal({
  show,
  emailCount,
  loading,
  onCancel,
  onConfirm
}: ConfirmationModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <div className="flex items-center mb-4">
          <AlertTriangle className="h-6 w-6 text-amber-500 mr-2" />
          <h3 className="text-xl font-semibold">Confirm Campaign Dispatch</h3>
        </div>
        
        <p className="text-gray-600 mb-4">
          You are about to dispatch this campaign to <span className="font-bold text-blue-600">{emailCount}</span> recipients.
        </p>
        
        <div className="bg-amber-50 p-3 rounded-md text-sm text-amber-700 mb-6">
          <p>
            <span className="font-medium">Important:</span> This action will start sending emails immediately.
            Please make sure your campaign is properly set up.
          </p>
        </div>
        
        <div className="flex gap-4">
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600"
          >
            {loading ? 'Dispatching...' : 'Confirm Dispatch'}
          </button>
        </div>
      </div>
    </div>
  );
}